import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["component", "render", "validFor", "notValidFor", "validForAny", "type", "redirectPath", "errorComponent"];
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import permissionValidations from './helpers';
import PermissionContext from './PermissionContext';
import PermissionError from './PermissionError';
import { ROUTE_TYPES } from './constants/permissions.constants';
var returnChildren = function returnChildren(permissions, validFor, notValidFor, validForAny, type, redirectPath, ErrorComponent, Component, props, renderMethod) {
  var valid = permissionValidations.validatePermissions(permissions, {
    validFor: validFor,
    notValidFor: notValidFor,
    validForAny: validForAny
  });
  if (valid) {
    return renderMethod ? renderMethod(props) : /*#__PURE__*/React.createElement(Component, props);
  }
  if (type === ROUTE_TYPES.REDIRECT) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: {
        pathname: redirectPath
      }
    });
  }
  if (type === ROUTE_TYPES.ERROR) {
    return /*#__PURE__*/React.createElement(ErrorComponent, _extends({}, props, {
      valid: valid
    }));
  }
  throw Error('Pass a Valid type!!!');
};
var PermissionRoute = function PermissionRoute(_ref) {
  var Component = _ref.component,
    renderMethod = _ref.render,
    validFor = _ref.validFor,
    notValidFor = _ref.notValidFor,
    validForAny = _ref.validForAny,
    type = _ref.type,
    redirectPath = _ref.redirectPath,
    ErrorComponent = _ref.errorComponent,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: function render(props) {
      return /*#__PURE__*/React.createElement(PermissionContext.Consumer, null, function (permissions) {
        return returnChildren(permissions, validFor, notValidFor, validForAny, type, redirectPath, ErrorComponent, Component, props, renderMethod);
      });
    }
  }));
};
PermissionRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  validFor: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  notValidFor: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  validForAny: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  redirectPath: PropTypes.string,
  errorComponent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  type: PropTypes.string.isRequired
};
PermissionRoute.defaultProps = {
  validFor: EMPTY_STRING,
  notValidFor: EMPTY_STRING,
  validForAny: EMPTY_STRING,
  redirectPath: '/',
  errorComponent: PermissionError
};
export default PermissionRoute;